module.exports = __webpack_public_path__ + "img/zhizhen.7216ee8c.png";